import Footer from "../Sub/Footer";
import webBanner from "../../images/about.webp";
import CommonHeader from "../Sub/CommonHeader";
import Banner from "../Sub/Banner";
import { Col, Row } from "react-bootstrap";

import React, { useEffect } from "react";
import { getSocialMediaSettings } from "../../reducers/commonReducer";
import { useDispatch, useSelector } from "react-redux";

const About = () => {
  let width = window.innerWidth;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSocialMediaSettings());
  }, []);

  const { getSocialMediaSettingsData } = useSelector(
    (state) => state.commonReducer
  );

  return (
    <>
      <CommonHeader />

      <div className="mutual-fund-container">
     

      <div className="fund-section elss-section">
        <img  src={webBanner} alt="ELSS" />
        <div className="fund-text">
        <h2 className="mutual-fund-heading text-start">
        About Us
      </h2>
          <h4>   Our company (<strong className="text-metual">TaxNwealth</strong>) started in 2003 with a
            mission to simplify financial and taxation services for individuals and
            businesses across India.</h4>
            <h3 className="mt-4 text-metual">Services We Offer</h3> 
            <p>
            <strong className="text-metual">TaxNwealth</strong> is a fully tax-compliant business. We
            provide complete support and solutions related to:
          </p>

          <p className="mb-0">• Income Tax Return (ITR) Filing</p>
          <p className="mb-0">• GST Registration & Filing</p>
          <p className="mb-0">• Mutual Fund Investment Assistance</p>
          <p className="mb-0">• Business Registration & Compliance</p>
          <p className="mb-0">• TDS Filing & Consultancy</p>
          <p>
            Whether you're an individual, a startup, or a growing business,
            <strong className="text-metual"> TaxNwealth</strong> has the tools and expertise to help you
            navigate your financial journey with confidence.
          </p>

          <h5 className="mt-4 text-metual">📍 Address</h5>
          <p className="mb-1">{getSocialMediaSettingsData?.address}</p>
          <p className="mb-4">
            {getSocialMediaSettingsData?.city}, {getSocialMediaSettingsData?.state},{" "}
            {getSocialMediaSettingsData?.zip}
          </p>

          {getSocialMediaSettingsData?.phone && (
            <p className="phone mbl-hide me-3 text-metual">
              <b>Contact no: +91-{getSocialMediaSettingsData.phone}</b>
            </p>
          )}
          {getSocialMediaSettingsData?.mail && (
            <p className="phone mbl-hide me-3 text-metual">
              <b>Email: {getSocialMediaSettingsData.mail}</b>
            </p>
          )}

        </div>
      </div>

     
    
    </div>
    

      <Footer />
    </>
  );
};

export default About;

